import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { AddToCalendar, AddToCalendarProps } from "./AddToCalendar"

export interface AddToCalendarWrapperBlokProps {
  blok: AddToCalendarProps & blokType
}

const S22AddToCalendar: React.FC<AddToCalendarWrapperBlokProps> = ({
  blok,
}) => (
  <SbEditable content={blok}>
    <AddToCalendar 
      label={blok.label}
      calendar_types={blok.calendar_types}
      />
  </SbEditable>
)

export default S22AddToCalendar
